<script>
    export default {
        name: "Splash",
        methods: {
            showLogin() {
                this.$store.commit("go", "login");
            },

            showSignup() {
                this.$store.commit("go", "signup");
            },
        },
    };
</script>


<template>
    <plain-page class="splash">
        <template #header>
            <nav>
                <button class="btn login" @click="showLogin">
                    Log In
                </button>
            </nav>

            <Emoji class="logo" name="unicorn" />

            <h1>
                Encryption in Browser, Storage in Cloud
            </h1>
            <div class="tagline">Your very own <em>hipster</em> password manager</div>

            <button class="btn signup" @click="showSignup">
                Sign Up
            </button>
        </template>

        <section>
            <h1>
                Simple
            </h1>
            <p>
                Lockbox says what’s on the tin - keeps your stuff safe. No fancy extensions, biometric unlocking, or
                anything else that could increase the probability of anyone but you accessing your personal data.
            </p>
        </section>
        <section>
            <h1>
                Secure
            </h1>
            <p>
                To ensure maximum safety, all your data is encrypted in browser, using state-of-art industrial cyphers.
                Only once we have made sure it’s safe, the data gets transmitted to the server for storage.
            </p>
        </section>
        <section>
            <h1>
                Awesome
            </h1>
            <p>
                To ensure maximum safety, all your data is encrypted in browser, using state-of-art industrial cyphers.
                Only once we are sure that the data can’t be cracked, it’s transmitted to the server for storage.
            </p>
        </section>
    </plain-page>
</template>



<style lang="scss">
    .plain-page.splash {
        header {
            display: flex;
            justify-content: center;
            text-align: center;
            font-size: 18px;

            nav {
                width: 100%;
                display: flex;
                justify-content: flex-end;
            }

            .login {
                color: #333;
                background: transparent;
            }

            .logo {
                height: 150px;
                width: 150px;
                margin: 2em 0;
            }

            .login {
                color: #666;
                &:hover {
                    color: #333;
                    text-decoration: none;
                    background: scale-color($lockbox-bg, $lightness: 60%);
                }
            }

            .signup {
                color: #fff;
                background: #bb2b18;

                &:hover {
                    text-decoration: none;
                    background: scale-color(#bb2b18, $lightness: -20%);
                }
            }
        }
    }

    @media (max-width: $mobile-break) {
        .plain-page.splash {
            header {
                .login  {
                    padding: 10px;
                }

                .logo {
                    margin: 1em 0;
                    height: 120px;
                    width: 120px;
                }
            }
        }
    }
</style>
